<template>
  <v-navigation-drawer
    v-model="drawer"
    fixed
    bottom
    right
    touchless
    class="woo-tutorial-help-drawer"
    mobile-breakpoint="960"
    temporary
  >
    <helper-playlist :onCloseHelp="toggleHelpDrawer"/>
  </v-navigation-drawer>
</template>
<script>
import hub, { Events } from '../helpers/EventHub';
import HelperPlaylist from './HelperPlaylist.vue';
export default {
  components: { HelperPlaylist },
  name: 'HelpDrawer',
  data() {
    return {
      drawer: false,
    };
  },
  computed: {},
  mounted() {
    hub.$on(Events.ShowHelp, this.toggleHelpDrawer);
  },
  destroyed() {
    this.resetHelpDrawer();
    this.drawer = false;
    document.getElementById('app').classList.remove('help-drawer-open');
    hub.$off(Events.ShowHelp, this.toggleHelpDrawer);
  },
  watch: {
    drawer(newValue) {
      if (newValue) {
        hub.$emit(Events.PauseVideo);
        document.getElementById('app').classList.add('help-drawer-open');
      } else {
        hub.$emit(Events.PlayVideo);
        this.resetHelpDrawer();
        document.getElementById('app').classList.remove('help-drawer-open');
      }
    },
  },
  methods: {
    toggleHelpDrawer() {
      this.drawer = !this.drawer;
      this.resetHelpDrawer();
    },
    resetHelpDrawer() {
      hub.$emit(Events.ResetHelpDrawer);
    },
  },
};
</script>
<style lang="scss">
.woo-tutorial-help-drawer {
  background-color: #f2f2f2 !important;
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
  max-height: 85% !important;
  z-index: 100 !important;
}
</style>
